import * as React from 'react'

// eslint-disable-next-line no-unused-vars
import { ISVG } from '../interfaces/svg'

export const MessageCircle = ({ title, titleId, ...props }: ISVG) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C18.661 18.1794 15.7189 19.9988 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00125 8.28112 5.82067 5.33907 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C17.3158 3.23813 20.7619 6.68422 21 11V11.5V11.5Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
